import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AnalyticsLoader = ({ script }) => {
  const location = useLocation();

  // Check if current page is admin panel or admin login
  const isAdminPage = location.pathname.startsWith('/admin') || location.pathname.startsWith('/yonetici');

  useEffect(() => {
    // Don't load analytics on admin pages
    if (isAdminPage) return;
    if (!script || script.trim() === '') return;

    // Remove existing analytics scripts
    const existingScripts = document.querySelectorAll('script[data-analytics="true"]');
    existingScripts.forEach(s => s.remove());

    // Create a container div
    const container = document.createElement('div');
    container.innerHTML = script;
    
    // Extract and execute scripts
    const scripts = container.querySelectorAll('script');
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');
      newScript.setAttribute('data-analytics', 'true');
      
      // Copy attributes
      Array.from(oldScript.attributes).forEach(attr => {
        newScript.setAttribute(attr.name, attr.value);
      });
      
      // Copy content
      if (oldScript.src) {
        newScript.src = oldScript.src;
      } else {
        newScript.textContent = oldScript.textContent;
      }
      
      document.head.appendChild(newScript);
    });
  }, [script, isAdminPage]);

  // Track page views on route change (exclude admin pages)
  useEffect(() => {
    // Don't track admin pages
    if (isAdminPage) return;
    
    if (window.gtag) {
      window.gtag('config', window.GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, isAdminPage]);

  return null;
};

export default AnalyticsLoader;
